import React from "react";
import Ingredient from "../Ingredient";
import avacadoWhole from "../../assets/images/ingredients/Avacado_half.png";
import AvacadoHalf from "../../assets/images/ingredients/Avacado.png";

const Avocado = ({ onClick, changeable=true, changed, hideable=true }) => {
    const handleClick = (event) => {
        event.stopPropagation();
        if (onClick) {
            onClick(event);
        }
    };
    return (
        <Ingredient
            name="Avocado"
            image={[AvacadoHalf, avacadoWhole]}
            changeable={changeable}
            changed={changed}
            hideable={hideable}
            onClick={handleClick}
        />
    );
};

export default Avocado;